export const camelize = (str: string): string => {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (letter: string, index: number) => {
      return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
    })
    .replace(/\s+/g, '');
};

/**
 * Normalizes an email for use as a Cognito username / stored identity by
 * trimming surrounding whitespace and lowercasing.
 */
export const normalizeEmail = (email: string): string => {
  return email.trim().toLowerCase();
};

/**
 * Takes a comma-separated string and returns a proper long disjunction formatted string
 * conjunction ex: input: 'a,b,c' output: 'a, b, and c'
 * disjunction ex: input: 'a,b,c' output: 'a, b, or c'
 */
export function formatStringList(str: string, type: 'conjunction' | 'disjunction'): string {
  const items = str.split(',').map((item) => item.trim());
  const coordinatingConjunction = type === 'conjunction' ? 'and' : 'or';

  if (items.length === 0) {
    return '';
  }

  if (items.length === 1) {
    return items[0];
  }

  if (items.length === 2) {
    return items.join(` ${coordinatingConjunction} `);
  }

  return `${items.slice(0, -1).join(', ')}, ${coordinatingConjunction} ${items[items.length - 1]}`;
}
